import BossModel from "@/models/BossModel";
import Version from '@/models/PlatinumPage/Version/Version'
import {sortBy} from "lodash";
import PlatinumRoute from "@/models/PlatinumRoute/PlatinumRoute";
import PlatinumHotel from "@/models/PlatinumHotel/PlatinumHotel";
import PlatinumExperience from "@/models/PlatinumExperience/PlatinumExperience";

export default class PlatinumPage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-page';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumPages';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name_nl: this.attr(null),
            name_en: this.attr(null),
            url: this.attr(null),
            parent_id: this.number(null).nullable(),
            platinum_page_version_id: this.number(null).nullable(),
            deleted_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            parents: this.belongsTo(PlatinumPage, 'parent_id'),
            version: this.belongsTo(Version, 'platinum_page_version_id'),
            versions: this.hasMany(Version, 'platinum_page_id'),
            oldestVersion: this.hasOne(Version, 'platinum_page_id'),
            platinumRoute: this.hasOne(PlatinumRoute, 'routeable_id'),
            platinumHotel: this.hasOne(PlatinumHotel, 'platinum_page_id'),
            platinumExperience: this.hasOne(PlatinumExperience, 'platinum_page_id'),
        }
    }

    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get().then((data) => {
                let pages = [];
                for (let key in data) {
                    pages.push(new PlatinumPage(data[key]));
                }
                return pages;
            });
    }

    Parents() {
        if (this.parents !== undefined && Array.isArray(this.parents)) {
            return this.parents;
        }

        const parents = [];
        let current = this.Parent();

        while (current) {
            parents.push(current);
            current = current.Parent();
        }

        this.parents = parents.reverse();

        return this.parents;
    }

    FullUrl() {
        let fullUrl = '';
        let parents = this.Parents();

        for (let key in parents) {
            fullUrl += '/' + parents[key].url;
        }

        return fullUrl + '/' + (this.url ? this.url : '');
    }

    static byParentId(parentId) {
        return this.query().orderBy('name_nl').where('parent_id', parentId).get();
    }

    static makeTree(nodes, parentId = null) {
        return nodes
            .filter((node) => node.parent_id === parentId)
            .reduce(
                (tree, node) => [
                    ...tree,
                    {
                        ...node,
                        children: this.makeTree(sortBy(nodes, ['name_nl']), node.id),
                    },
                ],
                [],
            )
    }

    AreChildrenAllowed() {
        return !this.Parent() || !this.Parent().Parent() || !this.Parent().Parent().Parent();
    }

    Parent() {
        return this.getRelated('parents');
    }

    Versions() {
        return this.getRelated('versions');
    }

    Version() {
        return this.getRelated('version');
    }

    PlatinumRoute() {
        return PlatinumRoute.findByRouteable(this.id, 'platinum_page');
    }
}
